<div [ngClass]="{'w-100 partial-height-mobile': !viewportService.isLargeViewPort(), 'h-100 width-400px': viewportService.isLargeViewPort()}"
     class="position-absolute overflow-x-hidden background-white z-max">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
         class="row position-fixed background-light-gray border-bottom border-dark-subtle p-3 m-0 z-max d-flex align-items-center height-details-header">
        <div (click)="back()" class="col-1 pt-4 pb-4 btn text-reset m-auto rounded-2" type="button">
            <i class="fa-solid fa-chevron-left color-secondary-information"></i>
        </div>
        <div class="col-2 m-0 d-flex justify-content-center">
            <app-precipitation-svg [online]="true" class="img-fluid img-max m-0"></app-precipitation-svg>
        </div>
        <div class="col-8 m-0">
            @if (!loading) {
                <div class="row m-auto">
                    <div class="fw-bold">{{ getAssetName() }}</div>
                    <div class="{{ statusMessageColorClass() }}">{{ statusMessage() }}</div>
                </div>
            }
        </div>
        <div (click)="close()" class="col-1 pt-4 pb-4 btn text-reset m-auto rounded-2" type="button">
            <i class="fa-solid fa-x color-secondary-information"></i>
        </div>
    </div>

    <div class="margin-top-details-header ps-3 pe-3 pb-3">
        @if (accumulated) {
            <div class="row mt-5 mb-3 w-100">
                <ngx-charts-bar-vertical
                        [barPadding]="0.05"
                        [dataLabelFormatting]="format"
                        [legend]="showLegend"
                        [results]="barDataset"
                        [scheme]="barScheme"
                        [showXAxisLabel]="false"
                        [showYAxisLabel]="false"
                        [xAxis]="false"
                        [yAxis]="true"
                        [yScaleMax]="highestBarValue">
                </ngx-charts-bar-vertical>
            </div>
        }
        @if (amount) {
            <div class="row mt-5 mb-3 w-100">
                <ngx-charts-line-chart
                        [animations]="true"
                        [results]="lineDataset"
                        [scheme]="scheme"
                        [showXAxisLabel]="false"
                        [timeline]="false"
                        [xAxis]="false"
                        [yAxisTickFormatting]="formatY"
                        [yAxis]="true"
                        [yScaleMax]="highestLineValue"
                        [yScaleMin]="0">
                </ngx-charts-line-chart>
            </div>
        }
        <div class="row mt-1 mb-3 graph-date-p pe-3 d-flex justify-content-between">
            @for (date of xAxisTicks; track date) {
                <span class="col dates-height vertical-text graph-label">{{ date }}</span>
            }
        </div>
        @if (xAxisTicks.length == 0) {
            <div class="row mt-1 mb-3">
                <span class="dates-height text-center">Loading...</span>
            </div>
        }
        <div class="mb-2">
            <div class="dropdown">
                <button [disabled]="loading || !canBeAltered"
                        aria-expanded="false"
                        aria-haspopup="true"
                        class="btn btn-info btn-info-shadow dropdown-toggle w-100"
                        data-bs-toggle="dropdown"
                        id="precipitationDateRangeDropDown"
                        type="button">
                    {{ selectedDateRangeName }}
                </button>
                <div aria-labelledby="precipitationDateRangeDropDown" class="dropdown-menu w-100">
                    @for (dateRange of selectableDateRanges; track dateRange) {
                        <div (click)="fetchData(dateRange)"
                            class="btn dropdown-item">{{ dateRange }}
                        </div>
                    }
                </div>
            </div>
        </div>
        <div class="mt-2 mb-2">
            <app-generic-button
                (click)="toggleAccumulated()"
                description="Show accumulated or amount"
                [buttonText]="buttonText"
                [disabled]="loading || !canBeAltered"/>
        </div>
        <app-generic-button
            (click)="toggleCustomize('/main/customize-precipitation-sample-point')"
            description="Customize precipitation-sample point"
            [alwaysShowText]="true"
            [buttonText]="'Customize'"
            [disabled]="loading || !canBeAltered"
            [primaryIcon]="'fa-solid fa-gear'"/>
      <app-asset-metadata [id]="asset()?.id" [relatedDeviceAssociations]="deviceAssociations()"/>
    </div>
</div>
